const UUID_CLAIM = 'uuid_claim';
const SINISTER_TYPE = 'sinister_type';
const VALIDATE_TYPE = 'validate_type';
export const getToken = () => {
  return localStorage.getItem(UUID_CLAIM);
};

export const setToken = (token) => {
  localStorage.setItem(UUID_CLAIM, token);
};

export const removeToken = () => {
  localStorage.removeItem(UUID_CLAIM);
};

export const getValidateType = () => {
  const type = localStorage.getItem(VALIDATE_TYPE);
  return type !== null ? Number(type) : null;
};

export const setValidateType = (type) => {
  localStorage.setItem(VALIDATE_TYPE, type);
};

export const removeValidateType = () => {
  localStorage.removeItem(VALIDATE_TYPE);
};

export const getSinisterType = () => {
  const type = localStorage.getItem(SINISTER_TYPE);
  return type !== null ? Number(type) : null;
};

export const setSinisterTypeLocal = (type) => {
  localStorage.setItem(SINISTER_TYPE, type);
};

export const removeSinisterType = () => {
  localStorage.removeItem(SINISTER_TYPE);
};
